import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import { useCurrentUser, authenticationActions } from '../../api';
import BlockedAccountDialog from '../Modals/BlockedAccountDialog';

const AccountStatusGate = ({ children }: { children: React.ReactElement }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { status } = useCurrentUser();
  const [showBlockedModal, setShowBlockedModal] = useState(false);

  useEffect(() => {
    // do not allow other routes if user status is disabled
    if (
      status === 'disabled' &&
      !router.pathname.includes('/reactivate') &&
      !router.pathname.includes('/register')
    ) {
      router.push('/reactivate');
    }

    // logout user if they want to create a new account
    if (status === 'disabled' && router.pathname.includes('/register')) {
      dispatch(authenticationActions.logout());
    }

    // show blocked popup and auto-logout if account is blocked
    if (status === 'blocked') {
      setShowBlockedModal(true);
      dispatch(authenticationActions.logout());
    }
  });

  return (
    <>
      {children}
      <BlockedAccountDialog
        isOpen={showBlockedModal}
        onClose={() => setShowBlockedModal(false)}
      />
    </>
  );
};

export default AccountStatusGate;
